<template>
  <div id="member-write-form-template">
    <h2 class="show-title">{{pageTitle}}</h2>
    <div class="row">
      <div class="col-md-2"></div>
      <div class="col-md-8">
        <div class="inline-input-group clearfix"></div>
        <div class="inline-input-group clearfix" v-if="postType === 'COUNSEL'">
          <label class="inline-input__label">이름<span class="required"> * </span></label>
          <label class="radio-inline label__radio">
            <input type="radio" v-model="authorNameType" value="public" name="authorNameTypeName" title="공개 선택">공개
          </label>
          <label class="radio-inline label__radio">
            <input type="radio" v-model="authorNameType" value="private" name="authorNameTypeName" title="비공개 선택">비공개
          </label>
          <input v-if="authorNameType === 'private'" ref="authorName" type="text" v-model="authorName" name="" class="input__text " placeholder="표시될 작성자를 입력해주세요" title="표시될 작성자를 입력해주세요">
        </div>
        <div class="inline-input-group clearfix">
          <label class="inline-input__label" for="title">제목 <span class="required"> * </span></label>
          <input type="text" v-model="title" name="title" id="title" class="input__text" placeholder="입력해주세요." title="입력해주세요.">
          <p class="text-count">{{title_length}}/100</p>
        </div>
        <div class="inline-input-group clearfix" v-if="postType !== 'COUNSEL'">
          <label class="inline-input__label">요약</label>
          <textarea v-model="excerpt" id="excerpt" name="excerpt" class="input__textarea input__textarea--thin" placeholder="입력해주세요." title="입력해주세요."></textarea>
          <p class="text-count helper-text">{{excerpt_length}}/300</p>
        </div>
        <div class="inline-input-group clearfix"  v-if="(postType === 'TIP') || (postType === 'MENTORING')">
          <label for="title" class="inline-input__label">메인노출 사진</label>
          <input type="file" id="imageInputFile" accept="image/gif, image/jpeg, image/png" v-on:change="imageUpload('imageInputFile')" title="imageInputFile 첨부파일 선택">
        </div>
        <div class="inline-input-group clearfix" v-if="postType !== 'MENTORING'">
          <label class="inline-input__label">썸네일<span class="required"> * </span></label>
          <label class="radio-inline label__radio">
            <input type="radio" v-model="imageUrl" value="/images/icon-face-fighting.png" id="imageUrl" name="imageUrlName" title="imageUrl 선택">
            <img src="/images/icon-face-fighting.png" class="online-counsel-icon" alt="파이팅"><span class="emotion-text">파이팅</span>
          </label>
          <label class="radio-inline label__radio">
            <input type="radio" v-model="imageUrl" value="/images/icon-face-sorrow.png" name="imageUrlName" title="imageUrlName 선택">
            <img src="/images/icon-face-sorrow.png" class="online-counsel-icon" alt="슬픔"><span class="emotion-text">슬픔</span>
          </label>
          <label class="radio-inline label__radio">
            <input type="radio" v-model="imageUrl" value="/images/icon-face-laugh.png" name="imageUrlName" title="imageUrlName 선택">
            <img src="/images/icon-face-laugh.png" class="online-counsel-icon" alt="웃음"><span class="emotion-text">웃음</span>
          </label>
          <label class="radio-inline label__radio">
            <input type="radio" v-model="imageUrl" value="/images/icon-face-angry.png" name="imageUrlName" title="imageUrlName 선택">
            <img src="/images/icon-face-angry.png" class="online-counsel-icon" alt="화남"><span class="emotion-text">화남</span>
          </label>
          <label class="radio-inline label__radio">
            <input type="radio" v-model="imageUrl" value="/images/icon-face-depress.png" name="imageUrlName" title="imageUrlName 선택">
            <img src="/images/icon-face-depress.png" class="online-counsel-icon" alt="우울"><span class="emotion-text">우울</span>
          </label>
          <label class="radio-inline label__radio">
            <input type="radio" v-model="imageUrl" value="/images/icon-face-frustration.png" name="imageUrlName" title="imageUrlName 선택">
            <img src="/images/icon-face-frustration.png" class="online-counsel-icon" alt="좌절"><span class="emotion-text">좌절</span>
          </label>
          <label class="radio-inline label__radio">
            <input type="radio" v-model="imageUrl" value="/images/icon-face-happiness.png" name="imageUrlName" title="imageUrlName 선택">
            <img src="/images/icon-face-happiness.png" class="online-counsel-icon" alt="행복"><span class="emotion-text">행복</span>
          </label>
          <label class="radio-inline label__radio">
            <input type="radio" v-model="imageUrl" value="/images/icon-face-challenge.png" name="imageUrlName" title="imageUrlName 선택">
            <img src="/images/icon-face-challenge.png" class="online-counsel-icon" alt="도전"><span class="emotion-text">도전</span>
          </label>
        </div>
      </div>
      <div class="col-md-2"></div>
    </div>
    <div class="row">
      <div class="col-md-2"></div>
      <div class="col-md-9">
        <div class="inline-input-group clearfix">
          <label class="inline-input__label" id="content">내용<span class="required"> * </span></label>
          <textarea name="smtTextareaInput" id="smtTextareaInput" v-model="content" rows="10" cols="100" style="width:100%; height:412px; min-width:610px; display: none;" title="smtTextareaInput 입력"></textarea>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-2"></div>
      <div class="col-md-8">
        <div class="inline-input-group clearfix"></div>
        <div class="inline-input-group clearfix">
          <label class="inline-input__label" for="tags">태그</label>
          <input type="text" v-model="tags" id="tags" class="input__text" placeholder="입력해주세요." title="입력해주세요.">
          <p class="helper-text">ex) #여행 #집 #배움</p>
        </div>
        <div class="inline-input-group clearfix" v-if="postType === 'REVIEW' || postType === 'COUNSEL'">
          <label label class="inline-input__label" for="opened">게시글 비공개</label>
          <input type="checkbox" v-model="opened" id="opened" title="opened 선택" />
        </div>
        <div class="inline-input-group clearfix">
          <div class="text-center submit-btn-group">
            <button type="button" class="submit-btn btn--org-line" @click="write">{{postId ? '글 수정' : '글 쓰기'}}</button>
            <button v-if="editWrite" type="button" class="submit-btn submit-btn--red" @click="remove">삭제</button>
          </div>
        </div>
      </div>
      <div class="col-md-2"></div>
    </div>
  </div>
</template>
<script>
  /* global CKEDITOR, smtInput */
  import Axios from 'axios';
  import Ckeditor from 'vue-ckeditor2';
  import CommonFn from '../../common-functions/commonFuntions';

  const commonFn = new CommonFn();

  export default {
    name: 'member-write-form-template',
    props: ['postType', 'org'],
    components: {
      Ckeditor,
    },
    data() {
      return {
        fiftyplusExcerpt: {
          height: 300,
          uploadUrl: '/api/file-uploads/imageDrag.do',
          filebrowserImageUploadUrl: '/api/file-uploads/ckeditorImageUpload.do',
          contentsCss: '/css/editor-memberform.css',
          font_defaultLabel: 'Spoqa Han Sans',
          font_names: `돋움; 굴림; 맑은 고딕; 바탕; 궁서; ${CKEDITOR.config.font_names}`,
          extraAllowedContent: 'area[shape,coords,href,target,alt,title];map[name];img[alt,src,title,usemap];iframe[frameborder,height,src,width]',
          toolbar: [
            { name: 'document', items: ['Source', '-', 'Templates'] },
            { name: 'clipboard', items: ['Cut', 'Copy', 'Paste', 'PasteText', 'PasteFromWord', '-', 'Undo', 'Redo'] },
            { name: 'editing', items: ['Find', 'Replace', '-', 'SelectAll', '-'] },
            '/',
            { name: 'basicstyles', items: ['Bold', 'Italic', 'Underline', 'Strike', 'Subscript', 'Superscript', '-', 'CopyFormatting', 'RemoveFormat'] },
            { name: 'paragraph', items: ['NumberedList', 'BulletedList', '-', 'Outdent', 'Indent', '-', 'Blockquote', 'CreateDiv', '-', 'JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock', '-', 'BidiLtr', 'BidiRtl'] },
            { name: 'links', items: ['Link', 'Unlink', 'Anchor'] },
            { name: 'insert', items: ['Image', 'Flash', 'Table', 'HorizontalRule', 'Smiley', 'SpecialChar', 'PageBreak', 'Iframe'] },
            '/',
            { name: 'styles', items: ['Styles', 'Format', 'Font', 'FontSize'] },
            { name: 'colors', items: ['TextColor', 'BGColor'] },
            { name: 'tools', items: ['Maximize', 'ShowBlocks'] },
            { name: 'about', items: ['About'] },
          ],
        },
        authorName: '',
        authorNameType: '',
        pageTitle: '',
        title: '',
        excerpt: '',
        imageUrl: '',
        content: '',
        tags: '',
        postId: '',
        url: '',
        message: '',
        editWrite: false,
        mainImgUrl: '',
        opened: false,
      };
    },
    computed: {
      title_length() {
        if (this.title === null) {
          return 0;
        }
        return this.title.length;
      },
      excerpt_length() {
        if (this.excerpt === null) {
          return 0;
        }
        return this.excerpt.length;
      },
    },
    methods: {
      confirmResult(resultValue) {
        this.confirmModalShow = false;
        this.confirmValue = resultValue;
      },
      vueConfirm(msg) {
        this.message = msg;
        this.confirmModalShow = true;
      },
      setAuthorNameType() {
        if (this.authorName === '' || !this.authorName) {
          this.authorNameType = 'public';
          return;
        }
        this.authorNameType = 'private';
      },
      remove() {
        const result = window.confirm('정말 삭제하시겠습니까?');
        if (result) {
          Axios.delete(`${this.url}/${this.postId}`).then(() => {
            alert('삭제되었습니다.');
            if (this.postType === 'TIP') {
              location.href = '/small-tip.do';
            } else if (this.postType === 'MENTORING') {
              location.href = '/mentoring.do';
            } else if (this.postType === 'FREE') {
              location.href = `/${this.org}/free-board.do`;
            } else if (this.postType === 'COUNSEL') {
              location.href = '/counsel-online.do';
            } else {
              location.href = `/${this.org}/review.do`;
            }
          }).catch((e) => {
            alert(e.response.data.msg);
          });
        }
      },
      write() {
        let tmpTagList = null;
        const tagList = [];
        if (this.tags && this.tags.replace(/ /gi, '').length !== 0) {
          tmpTagList = this.tags.replace(/#/gi, '#;');
          tmpTagList = tmpTagList.split('#');
          for (let i = 0; i < tmpTagList.length; i += 1) {
            let tag = tmpTagList[i];
            tag = tag.replace(/ {2}/gi, '');
            const indexSharp = tag.indexOf(';');
            if (tag.replace(/ {1}/gi, '') !== ';' && tag.replace(/ {1}/gi, '') !== '') {
              tagList.push(tag.substr(indexSharp + 1));
            }
          }
        }

        let authorNameValue = '';
        if (this.postType === 'COUNSEL') {
          if (this.authorNameType === 'private') {
            if (!this.authorName) {
              alert('작성자 이름을 입력해주세요');
              this.$refs.authorName.focus();
              return;
            }
            authorNameValue = this.authorName;
          } else {
            authorNameValue = '';
          }
        }

        smtInput();
        this.content = document.getElementById('smtTextareaInput').value;

        const pattern = /data:image*.*base64/;
        const re = pattern.test(this.content);
        if (re === true) {
          alert('등록할 수 없는 이미지 형태 입니다.');
          return;
        }

        if (!this.title) {
          alert('제목을 입력해주세요');
          $('#title').focus();
        } else if (this.title.length > 100) {
          alert('제목을 100자 이하로 입력해주세요');
          $('#title').focus();
        } else if (this.excerpt && this.excerpt.length > 300) {
          alert('요약을 300자 이하로 입력해주세요');
          $('#excerpt').focus();
        } else if (!this.imageUrl && this.postType !== 'MENTORING') {
          alert('아이콘을 입력해주세요');
          $('#title').focus();
        } else if (!this.content) {
          alert('내용을 입력해주세요');
        } else {
          let openedYn = '';
          if (this.opened === true) {
            openedYn = 'N';
          } else {
            openedYn = 'Y';
          }
          const Params = {
            authorName: authorNameValue,
            title: this.title,
            excerpt: this.excerpt,
            imageUrl: this.imageUrl,
            mainImgUrl: this.mainImgUrl,
            content: this.content,
            tags: tagList,
            opened: openedYn,
          };
          if (this.postId) {
            Axios.put(`${this.url}/${this.postId}`, Params).then(() => {
              alert('등록되었습니다.');
              location.href = `view.do?id=${this.postId}`;
            }).catch((e) => {
              alert(e.response.data.msg);
            });
          } else {
            Axios.post(`${this.url}`, Params).then((res) => {
              alert('등록되었습니다.');
              if (this.postType === 'COUNSEL' || this.postType === 'TIP' || this.postType === 'MENTORING') {
                location.href = `view.do?id=${res.data}`;
              } else if (res.data.id === undefined) {
                location.href = `view.do?id=${res.data}`;
              } else {
                location.href = `view.do?id=${res.data.id}`;
              }
            }).catch((e) => {
              alert(e.response.data.msg);
            });
          }
        }
      },
      getParams() {
        const url = window.location.search.substring(1);
        this.postId = commonFn.parseQueryString(url).id;
      },
      checkType() {
        if (this.postType === 'TIP') {
          this.pageTitle = '소소한 팁';
          this.url = '/api/member-posts/tips';
        } else if (this.postType === 'COUNSEL') {
          this.pageTitle = '온라인 상담';
          this.url = '/api/counsels/posts';
        } else if (this.postType === 'MENTORING') {
          this.pageTitle = '생애설계칼럼';
          this.url = '/api/counsels/mentors';
        } else if (this.postType === 'FREE') {
          this.pageTitle = '자유게시판';
          if (this.postId) {
            this.url = '/api/member-posts/free';
          } else {
            this.url = `/api/member-posts/free?org=${this.org}`;
          }
        } else {
          this.pageTitle = '후기';
          if (this.postId) {
            this.url = '/api/educations/reviews';
          } else {
            this.url = `/api/educations/reviews?org=${this.org}`;
          }
        }
      },
      imageUpload(id) {
        const formData = new FormData();
        const fileSize = document.getElementById(`${id}`).files[0].size;
        if (((fileSize / 1024) / 1024).toFixed(4) > 2) {
          alert('이미지파일은 최대 2MB 사이즈 까지만 업로드가 가능합니다.');
          document.getElementById(`${id}`).value = '';
        } else {
          formData.append('file', document.getElementById(`${id}`).files[0]);
          const Config = {
            /* eslint-disable */
            headers: { 'Content-Type': `multipart/form-data; boundary=${formData._boundary}` },
            /* eslint-enable */
          };
          Axios.post('/api/file-uploads', formData, Config).then((res) => {
            this.mainImgUrl = res.data.filename;
          }).catch((e) => {
            alert(e.response.data.msg);
          });
        }
      },
    },
    mounted() {
      this.getParams();
      this.checkType();
      this.setAuthorNameType();
      if (this.postId) {
        Axios.get(`${this.url}/${this.postId}`).then((response) => {
          const post = response.data || [];
          if (post.authorName === '' || !post.authorName) {
            this.authorNameType = 'public';
          } else {
            this.authorNameType = 'private';
          }
          this.authorName = post.authorName;
          this.title = post.title;
          this.excerpt = post.excerpt;
          this.content = post.content;
          document.getElementById('smtTextareaInput').value = post.content;
          this.imageUrl = post.imageUrl;
          this.mainImgUrl = post.mainImgUrl;
          if (post.opened === 'Y') {
            this.opened = false;
          } else {
            this.opened = true;
          }
          if (post.tags) {
            post.tags.forEach((item) => {
              this.tags += `#${item} `;
            });
          }
          this.editWrite = true;
        }).catch((e) => {
          alert(e.response.data.msg);
        });
      }
    },
  };
</script>



// WEBPACK FOOTER //
// MemberWriteForm.vue?0347f3be